import React from 'react'
import Slider from '../slider'
import round from 'lodash/round'
import { PriceSlider as PriceSliderConfig } from '../../utils/slider-configs'

const PriceSlider = (props) => {
  const MIN = PriceSliderConfig.min
  const MAX = PriceSliderConfig.max

  const valToPos = val => {
    return Math.cbrt(val * 5)
  }

  const posToVal = position => {
    const raw = Math.pow(position, 2) * (position / 5)
    // due to the deviation caused by the formula above, just return the MAX number if the result for 'raw' is equal or greater than it
    if (raw >= MAX) {
      return MAX
    }
    return round(raw, -1)
  }

  return (
    <Slider
      double
      inputs
      labelLeft='$'
      min={MIN}
      max={MAX}
      minDistance={1}
      value={props.value}
      onChange={props.onChange}
      mapValues={{
        valToPos,
        posToVal
      }}
    />
  )
}

export default PriceSlider



// WEBPACK FOOTER //
// ./src/components/price-slider/index.js